import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, X } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, waLink, DEFAULT_WA_MSG } from "../data/site";

export default function FloatingActions() {
  return (
    <>
      {/* Mobile bottom action bar */}
      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-[#27272A] bg-[#0B0B0C]/95 backdrop-blur-md"
        data-testid="mobile-action-bar"
      >
        <a
          href={PHONE_TEL}
          data-testid="floating-call-button"
          className="flex items-center justify-center gap-2 py-4 bg-[#FF5500] text-black font-telemetry text-sm font-semibold uppercase tracking-[0.12em]"
        >
          <Phone className="w-4 h-4" /> Call now
        </a>
        <a
          href={waLink(DEFAULT_WA_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          className="flex items-center justify-center gap-2 py-4 bg-[#16A34A] text-black font-telemetry text-sm font-semibold uppercase tracking-[0.12em]"
        >
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
      </div>

      {/* Desktop floating stack */}
      <div className="hidden md:flex fixed bottom-8 right-8 z-50 flex-col gap-3">
        <motion.a
          href={waLink(DEFAULT_WA_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="desktop-whatsapp-button"
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 pl-5 pr-6 py-3.5 rounded-full bg-[#16A34A] text-black font-telemetry text-xs font-semibold uppercase tracking-[0.15em] shadow-[0_8px_30px_rgba(22,163,74,0.35)]"
        >
          <MessageCircle className="w-5 h-5" /> WhatsApp us
        </motion.a>
        <motion.a
          href={PHONE_TEL}
          data-testid="desktop-call-button"
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 pl-5 pr-6 py-3.5 rounded-full bg-[#FF5500] text-black font-telemetry text-xs font-semibold uppercase tracking-[0.15em] shadow-[0_8px_30px_rgba(255,85,0,0.4)]"
        >
          <Phone className="w-5 h-5" /> {PHONE_DISPLAY}
        </motion.a>
      </div>
    </>
  );
}
